import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  DroolsBuildResponse,
  DroolsFileManagementRequest,
  DroolsNewFileRequest,
  FileDef,
} from '@compiere-ws/models/apiz-domains';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DroolsService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  private _url: string = undefined;

  get url(): string {
    if (this._url === undefined) {
      this._url = this.config.getBackendResource('drools');
    }
    return this._url;
  }

  getRules(path?: string): Observable<FileDef[]> {
    return this.http.get<FileDef[]>(`${this.url}/rules${path ? '?path=' + path : ''}`);
  }

  getRule(path: string): Observable<string> {
    return this.http.get<string>(`${this.url}/rule${path ? '?path=' + path : ''}`, { responseType: 'text' as 'json' });
  }

  saveRule(name: string, content: string, build?: boolean): Observable<DroolsBuildResponse> {
    const filename = name.endsWith('.drl') ? name : name + '.drl';
    const formData = new FormData();
    formData.append('file', new File([new Blob([content])], filename));
    formData.append('build', build ? 'true' : 'false');

    return this.http.post<any>(`${this.url}/rule`, formData);
  }

  newFile(request: DroolsNewFileRequest): Observable<FileDef[]> {
    return this.http.post<FileDef[]>(`${this.url}/new`, request);
  }

  copyRules(request: DroolsFileManagementRequest): Observable<FileDef[]> {
    return this.http.post<FileDef[]>(`${this.url}/copy`, request);
  }

  moveRules(request: DroolsFileManagementRequest): Observable<FileDef[]> {
    return this.http.post<FileDef[]>(`${this.url}/move`, request);
  }

  deleteRules(request: DroolsFileManagementRequest): Observable<FileDef[]> {
    return this.http.post<FileDef[]>(`${this.url}/delete`, request);
  }

  build(): Observable<DroolsBuildResponse> {
    return this.http.post<DroolsBuildResponse>(`${this.url}/build`, undefined);
  }
}
